module.exports = __webpack_public_path__ + "img/d-eco-zh.48337181.png";